// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1ZaQX","actions":"GroupTable_actions__19rN8","deleteModalFooter":"GroupTable_deleteModalFooter__1VKyR"};